export const PAGE = 1;
export const TRACK = 2;
export const IDENTIFY = 3;
export const ERROR = 4;
export const INFO = 5;
export const WARN = 6;
export const SUCCESS = 7;
